module.exports = __webpack_public_path__ + "img/photo-12.d764eac3.webp";